
/**
 * 
 * UploadField
 * 
 * 
 */
import React, { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Grid, Paper, Typography, Button } from '@material-ui/core';
import { getContentType } from '../UploadField/utils';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import PublishIcon from '@material-ui/icons/Publish';
import DoneIcon from '@material-ui/icons/Done';
import styles from './styles';
import { getSignature } from '../../Utils/api';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import ProgressProvider from '../ProgressProvider';
import axios from 'axios';


const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    }
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#2ca01c',
  },
}))(LinearProgress);

function SignatureUploadField({ setSubmitData }) {
    let maxFiles = 1;
    const classes = styles();
    const [inputValue, setInputValue] = useState(null);
    const [uploadError, setuploadError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showDownloadingProgress, setShowDownloadProgress] = useState(false);
    const [uploadingFileCount, setUploadingFileCount] = useState(false);
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const [file, setFile] = useState([]);
    const pushUniqueValue = (value) => {
        if (!file.includes(value)) {
        setFile(prevFiles => [...prevFiles, value]);
        }
    };

    useEffect(() => {
        setSubmitData((prevData) => {
            return {
                ...prevData,
                client_signature: inputValue ? inputValue.public_url : null
            }
        });
    }, [inputValue]);

    const onUpload = async (files) => {
        let uploadLimit = files && files.length <= maxFiles;
        if (uploadLimit) {
            const uploadedFileLength = files && files.length || 0;
            setShowDownloadProgress(true);
            setUploadingFileCount(uploadedFileLength);
            setLoading(true);
            const promises = await files.map(async (file, i) => {
                const Upload = getSignature;
                const fileName = file.name;
                const fileContentType = getContentType(fileName);
                return await Promise.resolve(Upload(fileName, fileContentType)
                .then(async (result) => {
                    if (result) {
                    return await axios.put(result.uploadURL, file, {
                        headers: {
                        Accept: 'application/json',
                            'Content-Type': fileContentType,
                        },
                        onUploadProgress: (e) => {
                            pushUniqueValue(fileName);
                            setUploadPercentage(Math.round((e.loaded / e.total) * 100))
                        },
                    }).then(() => {
                        return result;
                    })
                    }
                }))
            });
        
            Promise.all(promises).then((data) => {
                setInputValue(data[0])
                setLoading(false);
            }).finally(() => {
                setFile([]);
                setUploadPercentage(0);
                setShowDownloadProgress(false);
                setUploadingFileCount(false);
            });
    
        } else if (files) {
          setuploadError(`You can upload upto ${maxFiles} files(jpg, png, pdf) for this question`);
        }
    
    }

  const onDrop = useCallback(async (uploadedFiles) => {
    const acceptedFiles = uploadedFiles.map(file => {
      const fileName = file.name.replace(/[^a-zA-Z.0-9]/g, "");

      return new File([file], fileName, { type: file.type, lastModified: file.lastModified });
    });

    await onUpload(acceptedFiles)
  }, [onUpload]);

  const onDropRejected = useCallback((error) => {
    setuploadError(error[0].errors[0].message);
  }, []);

  const reset = () => {
    setInputValue(null);
    setUploadPercentage(0);
    setShowDownloadProgress(false);
    setUploadingFileCount(false);
  }

  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, open } = useDropzone({ accept: "image/*,application/pdf", multiple: true, onDrop, onDropRejected, disabled: loading });

  return (
    <Grid container justify="center" className={classes.root}>
        {inputValue && 
            <Grid className={classes.container}>
                <Grid className={classes.documentPreview}>
                    <aside className={classes.thumbsContainer}>
                        {inputValue && 
                            <div className={classes.thumb} key={file}>
                                <span className={classes.remove}>
                                    <HighlightOffIcon style={{ fill: "#2ca01c" }} onClick={reset} />
                                </span>
                                <div className={classes.thumbInner}>
                                    {["image/png", "image/jpeg"].includes(getContentType(inputValue.s3_file_key)) ? (
                                        <div>
                                            <img src={inputValue.public_url} alt="No image" className={classes.img} />
                                        </div>
                                    ) : getContentType(inputValue.s3_file_key) === "application/pdf" ? (
                                        <div>
                                            <img src={`https://www.sat7uk.org/wp-content/uploads/2018/11/kisspng-pdf-computer-icons-encapsulated-postscript-logo-pdf-5afde5cc758a98.9626072515265888764815.png`} className={classes.img} />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        }
                    </aside>
                </Grid>
            </Grid>
        }

        {!inputValue && 
            <>
                <Grid item xs={12} {...getRootProps({ className: 'dropzone' })} className={classes.container}>
                    <input {...getInputProps()} />
                    <Paper className={classes.upload}>
                        <ProgressProvider values={inputValue ? [100] : showDownloadingProgress && !uploadError ? [0, 50, 100] : [0]}>
                            {percentage => (<CircularProgressbarWithChildren
                                value={uploadPercentage || percentage}
                                className={classes.progress}
                                styles={buildStyles({
                                    pathColor: '#2ca01c',
                                    pathTransition:
                                        percentage === 0
                                            ? "none"
                                            : "stroke-dashoffset 0.5s ease 0s"
                                })}>
                                {(uploadPercentage || percentage) && !inputValue ? <div className={classes.percentage}>{uploadPercentage || percentage}%</div> : inputValue ? <DoneIcon className={classes.icon} /> : <PublishIcon className={classes.icon} />}
                            </CircularProgressbarWithChildren>)}
                        </ProgressProvider>
                    </Paper>
                    <Grid className={classes.animate}>
                        <div className={classes.circle} style={{ animationDelay: '0s' }} />
                        <div className={classes.circle} style={{ animationDelay: '1s' }} />
                        <div className={classes.circle} style={{ animationDelay: '2s' }} />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container className={classes.container} justify="center" direction="column">
                        <Typography component="span">{uploadPercentage ? `Uploading signature file ? labelValue : label}` : `Drag signature file to upload, or`}</Typography>
                        <Typography component="span">
                            <Button type="button" variant="contained" color="primary" onClick={open} className={classes.button}>
                                {`Choose Signature`}
                            </Button>
                        </Typography>
                    </Grid>
                </Grid>
            </>
        }
    </Grid>
  );
}

export default SignatureUploadField;
